window.EG_COLLECTION_PICKERS = (function () {
var mousepadPicker = {
  title: "Mousepad Finder",
  cta: "Start Finder",
  steps: [
    {
      key: "surface_type",
      question: "What kind of glide do you want?",
      mode: "single",
      filter_mode: "tag",
      help_title: "What does glide mean?",
      help_text: "Glide is the overall speed and stopping feel of the pad. This is the strongest performance choice in the finder.",
      help_points: [
        "Control gives more stopping power and steadier aim.",
        "Balanced is a safer middle ground for mixed play.",
        "Speed feels quicker and freer with less drag."
      ],
      options: [
        { label: "Control", value: "Surface Type__Control" },
        { label: "Balanced", value: "Surface Type__Balanced" },
        { label: "Speed", value: "Surface Type__Speed" }
      ]
    },
    {
      key: "surface_material",
      question: "Do you want a specialist surface, or keep it open?",
      mode: "single",
      filter_mode: "tag",
      help_title: "Why is this conditional?",
      help_text: "Some materials make much more sense for certain glide types. This step stays flexible so we do not force dead-end combinations.",
      help_points: [
        "Cloth is the most common and versatile option.",
        "Glass and Cordura are more specialist choices.",
        "No preference keeps this step broad and safer."
      ],
      options_by_answer_key: "surface_type",
      options_by_answer: {
        "Surface Type__Control": [
          { label: "Cloth", value: "Surface Material_Cloth" },
          { label: "No preference", value: "__any__" }
        ],
        "Surface Type__Balanced": [
          { label: "Cloth", value: "Surface Material_Cloth" },
          { label: "No preference", value: "__any__" }
        ],
        "Surface Type__Speed": [
          { label: "Cloth", value: "Surface Material_Cloth" },
          { label: "Glass", value: "Surface Material_Glass" },
          { label: "Cordura", value: "Surface Material_Cordura" },
          { label: "No preference", value: "__any__" }
        ]
      },
      options: [
        { label: "No preference", value: "__any__" }
      ]
    },
    {
      key: "firmness",
      question: "How soft should the base feel?",
      mode: "single",
      filter_mode: "tag_multi",
      help_title: "Why does base feel matter?",
      help_text: "Base feel changes how much the pad compresses under pressure, which affects comfort, feedback and consistency.",
      help_points: [
        "Softer bases feel cushioned and can feel more forgiving.",
        "Mid feels more stable and direct for many users.",
        "Firm feels flatter and more consistent under pressure."
      ],
      options: [
        { label: "Soft / Cushioned", value: ["Firmness__Extra Soft", "Firmness__Soft"] },
        { label: "Mid / Balanced", value: ["Firmness__Mid"] },
        { label: "Firm / Flat", value: ["Firmness__Hard"] },
        { label: "No preference", value: "__any__" }
      ]
    },
    {
      key: "movement_space",
      question: "How much room do you want for mouse movement?",
      mode: "single",
      filter_mode: "none",
      help_title: "Why ask about movement space?",
      help_text: "This does not hard-filter the collection. It helps us explain whether you should lean toward smaller, standard or larger pad sizes.",
      help_points: [
        "Large sweeping aim usually benefits from more pad space.",
        "Mixed arm and wrist aim suits most standard large sizes.",
        "Compact wrist-heavy play can work on smaller pads."
      ],
      options: [
        { label: "Large sweeping arm aim", value: "large_space" },
        { label: "Mixed arm + wrist", value: "medium_space" },
        { label: "Mostly wrist / compact movement", value: "compact_space" },
        { label: "Not sure", value: "unknown_space" }
      ]
    },
    {
      key: "secondary_priority",
      question: "What matters most after glide?",
      mode: "single",
      filter_mode: "none",
      help_title: "Why ask this?",
      help_text: "This helps shape the recommendation and explanation without over-filtering the catalog.",
      help_points: [
        "Comfort usually points toward softer, more forgiving bases.",
        "Consistency usually points toward more stable and direct feeling pads.",
        "Durability and maintenance matter if you want an easier long-term choice."
      ],
      options: [
        { label: "Comfort / softer feel", value: "comfort" },
        { label: "Consistency / stable tracking", value: "consistency" },
        { label: "Durability / low maintenance", value: "durability" },
        { label: "Lowest possible friction", value: "low_friction" },
        { label: "Not sure", value: "unsure" }
      ]
    }
  ],
  fallback: {
    relaxOrder: ["firmness", "surface_material", "surface_type"]
  },
summary: {
  glide: function (surfaceType) {
    var v = String(surfaceType || "");

    if (v === "Surface Type__Control") {
      return "You’ll benefit from a control-focused surface for better stopping power and precision.";
    }

    if (v === "Surface Type__Balanced") {
      return "A balanced surface will give you a mix of speed and control without leaning too far either way.";
    }

    if (v === "Surface Type__Speed") {
      return "A faster surface will reduce drag and help with quick, effortless movement.";
    }

    return "";
  },

  size: function (movement) {
    var m = String(movement || "");

    if (m === "large_space") {
      return "A larger pad (XL or XXL) will better suit your wider arm movements.";
    }

    if (m === "medium_space") {
      return "A large or XL pad will give you enough room for both arm and wrist movement.";
    }

    if (m === "compact_space") {
      return "A smaller or standard pad is enough here, as your movements are more compact.";
    }

    return "";
  },

  priority: function (priority) {
    var v = String(priority || "");

    if (v === "comfort") {
      return "Softer pads will feel more cushioned and forgiving over longer sessions.";
    }

    if (v === "consistency") {
      return "A more stable surface will help keep your aim predictable and repeatable.";
    }

    if (v === "durability") {
      return "More durable materials will last longer and be easier to maintain.";
    }

    if (v === "low_friction") {
      return "Lower friction will give you faster glide with less resistance.";
    }

    return "";
  }
},
  recommendation: {
    build: function (answers, plan) {
      var glide = String(answers.surface_type || "");
      var material = String(answers.surface_material || "");
      var firmness = answers.firmness;
      var movement = String(answers.movement_space || "");
      var priority = String(answers.secondary_priority || "");

      var opening = "";
      var notes = [];

      if (glide === "Surface Type__Control") {
        opening = "You are leaning toward a more control-focused pad with stronger stopping power.";
      } else if (glide === "Surface Type__Balanced") {
        opening = "You are leaning toward a balanced pad that sits in the middle of speed and control.";
      } else if (glide === "Surface Type__Speed") {
        opening = "You are leaning toward a faster pad with a freer, lower-drag glide.";
      } else {
        opening = "You are leaning toward an all-round mousepad choice.";
      }

      if (material === "Surface Material_Cloth") {
        notes.push("Cloth keeps the results focused on the most versatile surface type.");
      } else if (material === "Surface Material_Glass") {
        notes.push("Glass keeps the results focused on specialist fast surfaces.");
      } else if (material === "Surface Material_Cordura") {
        notes.push("Cordura keeps the results focused on more durable, speed-oriented surfaces.");
      }

      if (movement === "large_space") {
        notes.push("Your playstyle will benefit from larger pad sizes where possible.");
      } else if (movement === "compact_space") {
        notes.push("You do not need the very largest pads unless you want extra desk coverage.");
      }

      if (priority === "comfort") {
        notes.push("You’ll benefit from a softer, more comfortable desk feel.");
      } else if (priority === "consistency") {
        notes.push("You’ll benefit from a more stable and predictable feel under pressure.");
      } else if (priority === "durability") {
        notes.push("You’ll benefit from easier maintenance and better long-term durability.");
      } else if (priority === "low_friction") {
        notes.push("You’ll benefit from the lowest possible drag and the easiest glide.");
      }

      if (plan && plan.mode === "closest" && plan.omitKeys && plan.omitKeys.firmness && firmness && firmness !== "__any__") {
        notes.push("We widened base feel because your exact combination returned no matches.");
      }

      if (plan && plan.mode === "closest" && plan.omitKeys && plan.omitKeys.surface_material && material && material !== "__any__") {
        notes.push("We also widened material because your exact material choice was too restrictive.");
      }

      var combined = [opening].concat(notes).join(" ");
      return combined.replace(/\s+/g, " ").trim();
    }
  }
};

  return {
    default: null,
    handles: {
      "gaming-mousepads": mousepadPicker,
      "test-collection": mousepadPicker
    }
  };
})();